export function getPaymentByRate(creditSum, term, rate) {
    return Math.ceil(creditSum * (rate / (1 - (1 + rate) ** -term)));
}
